/** Variant helpers (storefront + POS + stock). variants: [{ size, color, stock, enabled }], size "" when the product has no size. */
const same = (a, b) => (a || "") === (b || "");
export function hasRealVariants(product) {
  return Array.isArray(product?.variants) && product.variants.some(v => v.enabled !== false);
}
export function enabledVariants(product) {
  return (product?.variants || []).filter(v => v.enabled !== false);
}
export function availableColorsForSize(product, size) {
  if (!hasRealVariants(product)) return product?.colors || [];
  return Array.from(new Set(enabledVariants(product).filter(v => same(v.size, size)).map(v => v.color)));
}
export function availableSizesForColor(product, color) {
  if (!hasRealVariants(product)) return product?.sizes || [];
  return Array.from(new Set(enabledVariants(product).filter(v => v.color === color).map(v => v.size)));
}
export function stockFor(product, size, color) {
  if (hasRealVariants(product)) {
    const v = enabledVariants(product).find(v => same(v.size, size) && v.color === color);
    return v ? Number(v.stock || 0) : 0;
  }
  return Number((size ? product?.stock_by_size?.[size] : product?.stock) ?? product?.stock ?? 0);
}
export function comboExists(product, size, color) {
  if (!hasRealVariants(product)) return true;
  return enabledVariants(product).some(v => same(v.size, size) && v.color === color);
}
export function sizeLabel(product) {
  const t = product?.variant_type;
  if (t === "pointure") return "Pointure";
  if (t === "format") return "Format";
  if (t === "taille") return "Taille";
  return /chaussure|mule|sandale|escarpin|talon|basket|botte/i.test(product?.category || "") ? "Pointure" : /sac|pochette|cabas/i.test(product?.category || "") ? "Format" : "Taille";
}
